/**
 * OVERRIDE CheckboxWidget.jsx
 */

import CheckboxWidget from '../../../../components/Widgets/CheckboxWidget/CheckboxWidget';

export default CheckboxWidget;